<template>
    <div>
        <form :action="action"
              class="dropzone"
        ></form>
    </div>
</template>

<script setup>
    import {onMounted} from 'vue';
    import Dropzone from "dropzone";
    import 'dropzone/dist/dropzone.css';
    import {LGDLogger} from "../../lib/LGDLogger";
    const props = defineProps(['onsuccess', 'action']);

    Dropzone.autoDiscover = false;
    onMounted(() => {
        try {
            new Dropzone(".dropzone", {
                maxFilesize: 10,
                accept: function (file, done) {
                    if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf|docx|doc|tiff)$/i.test(file.name)) {
                        done($t('Ugyldig filformat. Prøv en annen fil.'));
                        return
                    }
                    done();
                },
                dictDefaultMessage: $t('Dra en fil eller trykk for å laste opp. <br>Video- og lydfiler kan ikke lastes opp, og filen må være mindre enn 10MB.'),
            }).on("complete", function(file) {
                props.onsuccess()
            }).on('error', function(file, errorMessage) {
                console.log(errorMessage)
            });
        } catch (error) {
            LGDLogger.warn('Error in FileUploader.vue', error)
        }
    })
</script>